import { render, staticRenderFns } from "./SubjectResultsView.vue?vue&type=template&id=0e56eb54&scoped=true&"
import script from "./SubjectResultsView.vue?vue&type=script&lang=js&"
export * from "./SubjectResultsView.vue?vue&type=script&lang=js&"
import style0 from "./SubjectResultsView.vue?vue&type=style&index=0&id=0e56eb54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e56eb54",
  null
  
)

export default component.exports